import { cn } from '@/lib/utils';

interface FoundersOnlyLogoProps {
  className?: string;
  size?: 'sm' | 'md';
}

export function FoundersOnlyLogo({
  className,
  size = 'md',
}: FoundersOnlyLogoProps) {
  return (
    <div
      className={cn(
        'inline-flex items-baseline gap-[0.16em]',
        size === 'sm' ? 'text-base' : 'text-lg',
        className
      )}
      aria-label="Founders Only"
    >
      <b className="font-founders-only-sans font-bold tracking-[-0.025em] text-foreground">
        Founders
      </b>
      <span className="font-founders-only-serif text-[1.18em] italic text-foreground">
        Only.
      </span>
    </div>
  );
}
